import { OrderDetails, OverdudedOrder } from 'store/ordersStore/reducer';

/**
 * Events from signal
 */
export enum SignalREvent {
    OrdersCountChanged = 'OrdersCountChanged',
    OrderChanged = 'OrderChanged',
    OrderAdded = 'OrderAdded',
    OverdudedOrdersChanged = 'OverdudedOrdersChanged',
}

/**
 * Map of event names to payload types
 */
export interface SignalREventsMap {
    OrdersCountChanged: number;
    OrderChanged: OrderDetails;
    OrderAdded: OrderDetails;
    OverdudedOrdersChanged: OverdudedOrder[];
}

export type SignalREventName = keyof SignalREventsMap;
